<template>
    <div class="row" v-loading="isLoading">
        <div class="form-group col-6">
            <label class="mb-0" :for="'profile' + _uid">Анкета заявки</label>
            <ProfileSelect v-model="profile_id" :request_id="deal.request_id" :id="'profile' + _uid"/>
            <div v-if="field_errors.hasOwnProperty('profile_id')" class="help-block invalid-feedback d-block" v-html="field_errors['profile_id'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'salon_legal_entity_id' + _uid">Юрлицо площадки</label>
            <CounteragentSelect v-model="salon_legal_entity_id" :filter_type="'company'" class="multiselect-bootstrap" :id="'salon_legal_entity_id' + _uid"/>
            <div v-if="field_errors.hasOwnProperty('salon_legal_entity_id')" class="help-block invalid-feedback d-block" v-html="field_errors['salon_legal_entity_id'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'polnaya_stoimost_avto' + _uid">Полная стоимость ТС</label>
            <input type="number" class="form-control" name="polnaya_stoimost_avto" :id="'polnaya_stoimost_avto' + _uid" v-model="polnaya_stoimost_avto">
            <div v-if="field_errors.hasOwnProperty('polnaya_stoimost_avto')" class="help-block invalid-feedback d-block" v-html="field_errors['polnaya_stoimost_avto'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'nalichnih' + _uid">Наличных денежных средств</label>
            <input type="number" class="form-control" name="nalichnih" :id="'nalichnih' + _uid" v-model="nalichnih">
            <div v-if="field_errors.hasOwnProperty('nalichnih')" class="help-block invalid-feedback d-block" v-html="field_errors['nalichnih'][0]"/>
        </div>
        <div v-if="in_credit" class="form-group col-6">
            <label class="mb-0" :for="'zaem' + _uid">Заёмные денежные средства</label>
            <input type="number" class="form-control" name="zaem" :id="'zaem' + _uid" v-model="zaem">
            <div v-if="field_errors.hasOwnProperty('zaem')" class="help-block invalid-feedback d-block" v-html="field_errors['zaem'][0]"/>
        </div>
        <div v-if="in_credit" class="form-group col-6">
            <label class="mb-0" :for="'bank' + _uid">Банк</label>
            <input type="text" class="form-control" name="bank" :id="'bank' + _uid" v-model="bank">
            <div v-if="field_errors.hasOwnProperty('bank')" class="help-block invalid-feedback d-block" v-html="field_errors['bank'][0]"/>
        </div>
<!--        <div class="form-group col-6">-->
<!--            <label class="mb-0" :for="'expenses_incurred' + _uid">Расходы на продажу ТС</label>-->
<!--            <input type="number" class="form-control" name="expenses_incurred" :id="'expenses_incurred' + _uid" v-model="expenses_incurred">-->
<!--            <div v-if="field_errors.hasOwnProperty('expenses_incurred')" class="help-block invalid-feedback d-block" v-html="field_errors['expenses_incurred'][0]"/>-->
<!--        </div>-->
        <div class="form-group col-12 text-right">
            <button @click="generate" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>
        </div>
    </div>
</template>

<script>
import CounteragentSelect from "../../counteragents/CounteragentSelect";
import ProfileSelect from "../../requests/profiles/ProfileSelect";
import formMixin from "../formMixin";
import _ from "lodash";

export default {
    name: "DKPBuCredit",
    mixins: [formMixin],
    components: {CounteragentSelect, ProfileSelect},
    props: {
        deal: {
            type: Object,
            required: true,
        },
        form_name: {
            type: String,
            required: true,
        },
        condition: {
            type: String,
            required: true,
        },
        in_credit: {
            type: Boolean,
            required: true,
        }
    },
    data: () => ({
        isLoading: false,
        profile_id: null,
        salon_legal_entity_id: null,
        polnaya_stoimost_avto: null,
        nalichnih: null,
        zaem: null,
        bank: null,
        expenses_incurred: null,
        field_errors: {},
    }),
    mounted() {
        this.profile_id = this.deal.profile_id;
        this.salon_legal_entity_id = this.deal.salon_legal_entity_id;
        this.polnaya_stoimost_avto = this.deal.in_credit ? this.deal.credit_sale_amount / 100 : this.deal.sale_amount / 100;
        this.nalichnih = this.deal.in_credit ? this.deal.credit_initial_payment / 100 : this.deal.sale_initial_payment / 100;
        this.zaem = this.deal.in_credit ? this.deal.credit_amount / 100 : null;
        this.bank = this.deal.in_credit ? this.deal.credit_bank.company_name : null;
    },
    computed: {
        form_params() {
            return {
                form_name: this.form_name,
                deal_id: this.deal.id,
                profile_id: this.profile_id,
                salon_legal_entity_id: this.salon_legal_entity_id,
                polnaya_stoimost_avto: this.polnaya_stoimost_avto,
                nalichnih: this.nalichnih,
                zaem: this.zaem,
                bank: this.bank,
                expenses_incurred: this.expenses_incurred,
            };
        }
    }
}
</script>

<style scoped>

</style>
